module.exports = __webpack_public_path__ + "static/media/coursePage.d41d8cd9.scss";


//////////////////
// WEBPACK FOOTER
// ./src/pages/SingleCourse/coursePage.scss
// module id = 2312
// module chunks = 0